// removed by extract-text-webpack-plugin
module.exports = {"balanceWeight":"balanceWeight__2uns2ZBP","right":"right__1y3agSHH","btn":"btn__2nCD-hje"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYFilter/components/OYBalanceWeight/index.module.less
// module id = 729
// module chunks = 1